import { Button, Stack, Typography } from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { suppliesDetailPageRoute } from "../SuppliesDetailPage/SuppliesDetailPage";

export const SuppliesDetailListPageHeader = (props: { rootPermission: Permission; handle: string }) => {
  const navigate = useNavigate();

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        <Typography variant="inherit">{props.handle}</Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        {isAuthorized(props.rootPermission, PermissionAction.Create) && (
          <Button
            onClick={() => navigate(suppliesDetailPageRoute.getPath({ id: 0, crudMode: "edit" }))}
            variant="outlined"
          >
            + New
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
